import { useState } from 'react';

import { getListPayload } from 'coreOld/utils';
import { CostingStatus } from 'partsOld/enums';
import { useGetCostingList } from 'partsOld/hooks';
import { ICompanyPart, ICost } from 'partsOld/types';

import { columns } from './columns';
import CostingTabView from './CostingTabView';

interface IProps {
  part?: Partial<ICompanyPart>;
}

const getPayload = (part: Partial<ICompanyPart>) => {
  return getListPayload({ corporatePartId: part?.id }, { pageSize: 10 });
};

const CostingTab = ({ part }: IProps) => {
  const { records, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } = useGetCostingList(
    getPayload(part)
  );

  const [selectedCost, setSelectedCost] = useState<ICost>();

  const onRowClick = (row: ICost) => {
    if (row?.status === CostingStatus.Expired) {
      return;
    }

    setSelectedCost(row);
  };

  return (
    <CostingTabView
      tableColumns={columns}
      costingList={records}
      part={part}
      selectedCost={selectedCost}
      setSelectedCost={setSelectedCost}
      onRowClick={onRowClick}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};

export default CostingTab;
